// extracted by mini-css-extract-plugin
export default {"title":"DrCC2XNkjVlvPKA2VWMF","sub-title":"j2yaS_ToEk5TarPRieuB"};